import { useState, useEffect } from 'react';
import axios from 'axios';
import { Badge } from '@/components/ui/badge';
import Navbar from '@/components/custom/Navbar';
import Footer from '@/components/custom/Footer';
import ArtisanCard from '@/components/custom/ArtisanCard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ArtisansPage = () => {
  const [artisans, setArtisans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArtisans = async () => {
      try {
        const response = await axios.get(`${API}/artisans`);
        setArtisans(response.data);
      } catch (error) {
        console.error('Error fetching artisans:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchArtisans();
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      {/* Header */}
      <section className="pt-24 pb-12 bg-secondary/30">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <Badge variant="outline" className="mb-4">Our Artisans</Badge>
          <h1 className="text-4xl md:text-5xl font-medium mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Meet the Makers
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl">
            Every product on GinsGood is created by skilled artisans preserving 
            centuries-old traditions. Learn their stories and support their craft.
          </p>
        </div>
      </section>

      {/* Artisans Grid */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1,2,3,4,5,6].map(i => (
                <div key={i} className="aspect-[4/5] bg-muted rounded-xl animate-pulse" />
              ))}
            </div>
          ) : artisans.length === 0 ? (
            <div className="text-center py-24">
              <p className="text-lg text-muted-foreground">No artisans found.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="artisans-grid">
              {artisans.map(artisan => (
                <ArtisanCard key={artisan.id} artisan={artisan} />
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ArtisansPage;
